var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B6B76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 14.9996V0L14.9997 1.75776V14.9996H5.625ZM7.49995 13.7495H9.37489V12.4997H7.49995V13.7495ZM7.49995 11.2497H9.37489V9.99965H7.49995V11.2497ZM7.49995 8.74981H9.37489V7.49978H7.49995V8.74981ZM7.49995 6.24976H9.37489V4.99992H7.49995V6.24976ZM7.49995 3.74989H9.37489V2.49987H7.49995V3.74989ZM11.2498 13.7495H13.1248V12.4997H11.2498V13.7495ZM11.2498 11.2497H13.1248V9.99965H11.2498V11.2497ZM11.2498 8.74981H13.1248V7.49978H11.2498V8.74981ZM11.2498 6.24976H13.1248V4.99992H11.2498V6.24976ZM0 15V3.67216L4.37481 2.85187V15H0ZM1.25002 13.75H3.12497V12.5002H1.25002V13.75ZM1.25002 11.2501H3.12497V10.0001H1.25002V11.2501ZM1.25002 8.75026H3.12497V7.50023H1.25002V8.75026ZM1.25002 6.25021H3.12497V5.00037H1.25002V6.25021Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.38487ef0.svg";
export { ForwardRef as ReactComponent };